import { SVGProps } from 'react'

function Arrows(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={props.width ?? 32}
      height={props.height ?? 32}
      fill="none"
      viewBox="0 0 32 32"
      {...props}
    >
      <g
        stroke={props.color ?? '#1B335C'}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        strokeOpacity={props.strokeOpacity ?? 1}
      >
        <path d="M9.5 27a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7ZM6 9l5 5M11 9l-5 5M23 21l5 5M28 21l-5 5M18 10V5h5" />
        <path d="m18 5 2 2c5 5 1 11-3 12" />
      </g>
      <defs>
        <clipPath id="a">
          <path fill="#fff" d="M0 0h32v32H0z" />
        </clipPath>
      </defs>
    </svg>
  )
}

export default Arrows
